import BaseEndpoint from "../common/BaseEndpoint";

const apiPath = '/api/v1/a/mst';

class MutualSettlementEndPoint extends BaseEndpoint {
  report(params) {
    return this.client.$get(`${apiPath}/`, {params});
  }

  add(data) {
    return this.client.$post(`${apiPath}/add`, data);
  }

  remove(data) {
    return this.client.$delete(`${apiPath}/remove`, {data});
  }

  file(params) {
    return this.client.$get(`${apiPath}/file`, {params, responseType: 'arraybuffer'});
  }
}

export default MutualSettlementEndPoint;